import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MmButtonModule } from '@metromarkets/components';
import { EmailSentComponent } from './email-sent.component';

@NgModule({
  imports: [
    RouterModule,
    TranslateModule,
    MmButtonModule,
  ],
  declarations: [EmailSentComponent],
  exports: [EmailSentComponent],
})
export class EmailSentModule {}
